<template>
  <el-form label-width="120px" @submit.native.prevent>
    <div v-show="!isCollapsed">
      <el-form-item label="網址">
        <el-input v-model="form.UrlKey"></el-input>
      </el-form-item>

      <el-form-item label="標題">
        <el-input v-model="form.Title" @input="$emit('title-changed', form.Title)"></el-input>
      </el-form-item>

      <el-form-item label="介紹">
        <el-input v-model="form.Description" type="textarea" autosize></el-input>
      </el-form-item>

      <el-form-item label="關鍵字">
        <el-input v-model="form.Keywords"></el-input>
      </el-form-item>

      <el-form-item label="封面圖片">
        <el-upload
          v-loading="isProcessingImage"
          ref="elupload"
          accept="image/*"
          class="left"
          style="height: 180px;"
          drag
          action
          :auto-upload="true"
          :http-request="processCoverFile">
          <img
            ref="coverImg"
            v-show="coverImageSrc"
            @load="onLoaded"
            class="preview"
            :src="coverImageSrc"
            style="max-width: 100%;max-height: 120px;"/>
          <i v-show="!(coverImageSrc)" class="el-icon-upload"></i>
          <div class="el-upload__text">
            將文件拖曳至此，或
            <em>點擊上傳</em>
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="日期">
        <el-date-picker v-model="form.Date" class="left" type="date" placeholder="選擇日期"></el-date-picker>
      </el-form-item>
    </div>

    <div style="padding-left: 120px;">
      <div v-show="isCollapsed">詳細資訊</div>

      <el-divider>
        <i v-show="!isCollapsed" class="clickable el-icon-arrow-up" @click="isCollapsed=true">收起</i>
        <i v-show="isCollapsed" class="clickable el-icon-arrow-down" @click="isCollapsed=false">展開</i>
      </el-divider>

      <content-editor v-model="form.contentJsonArr" />
    </div>
  </el-form>
</template>

<script>
import ImageThumbnailer from '@/utils/ImageThumbnailer.js'
import ContentEditor from '@/utils/content-editor/components/ContentEditor.vue'
export default {
  components: {
    ContentEditor
  },
  props: {
    form: {
      default: () => {
        return {}
      }
    }
  },
  data: () => {
    return {
      isCollapsed: false,
      isProcessingImage: false,
      coverImageSrc: null
    }
  },
  computed: {
    isEdit () {
      return this.$route.name !== 'createWork'
    }
  },
  methods: {
    // cover image
    processCoverFile (e) {
      let isImg = e.file.type.indexOf('image') >= 0
      if (!isImg) {
        alert('請上傳圖片檔案')
        return
      }
      this.isProcessingImage = true
      this.$refs.elupload.clearFiles()
      // 壓縮cover image
      let coverImageCompressPromise = new Promise((resolve, reject) => {
        let opts = {
          maxWidth: 512,
          maxHeight: 512,
          format: e.file.type // 避免封面使用透明背景，需要保留format png
        }
        ImageThumbnailer.shared.requestCompress(
          e.file,
          blob => {
            resolve(blob)
          },
          opts
        )
      })
      // 壓縮thumb
      let coverImageThumbCompressPromise = new Promise((resolve, reject) => {
        let opts = {
          maxWidth: 100,
          maxHeight: 100,
          format: e.file.type // 避免封面使用透明背景，需要保留format png
        }
        ImageThumbnailer.shared.requestCompress(
          e.file,
          blob => {
            resolve(blob)
          },
          opts
        )
      })

      Promise.all([
        coverImageCompressPromise,
        coverImageThumbCompressPromise
      ]).then(results => {
        let coverBlob = results[0]
        let thumbBlob = results[1]
        this.onThumb(coverBlob, thumbBlob)
      })
    },
    onThumb (blob, thumb) {
      this.form.newCoverImageThumbBlob = thumb
      this.form.newCoverImageBlob = blob
      this.form.src = URL.createObjectURL(blob)
      this.coverImageSrc = this.form.src
      this.isProcessingImage = false
    },
    onLoaded (evt) {
      if (evt.target.src.startsWith('http')) return

      const removeBlobs = () => {
        this.form.src = undefined
        this.coverImageSrc = this.form.CoverImageUrl
        this.form.newCoverImageBlob = undefined
        this.form.newCoverImageThumbBlob = undefined
      }
      const uploadBlobs = () => {
        this.isProcessingImage = true

        let coverPrefix = this.isEdit
          ? `work/${this.form.ID}/cover-`
          : `work/cover-${this.formTitle}-`
        let coverThumbPrefix = this.isEdit
          ? `work/${this.form.ID}/cover-thumb-`
          : `work/cover-thumb-${this.formTitle}-`

        let promise1 = this.$services.firebase.upload(
          this.form.newCoverImageBlob,
          coverPrefix
        )
        let promise2 = this.$services.firebase.upload(
          this.form.newCoverImageThumbBlob,
          coverThumbPrefix
        )

        Promise.all([promise1, promise2]).then(urls => {
          let coverUrl = urls[0]
          let thumbUrl = urls[1]
          this.form.CoverImageUrl = coverUrl
          this.form.CoverImageThumbUrl = thumbUrl
          this.form.newCoverImageBlob = undefined
          this.form.newCoverImageThumbBlob = undefined
          this.form.src = undefined
          this.isProcessingImage = false
          this.coverImageSrc = this.form.CoverImageUrl
          this.$set(this.form, 'CoverImageUrl', coverUrl)
        })
      }

      let img = this.$refs.coverImg
      let size = {
        w: img.naturalWidth,
        h: img.naturalHeight
      }
      if (size.w !== 512 || size.h !== 512) {
        alert('錯誤: 檔案尺寸錯誤! 請上傳 512x512')
        removeBlobs()
      } else {
        uploadBlobs()
      }
      URL.revokeObjectURL(evt.target.src)
    }
  },
  created () {
    this.form.contentJsonArr = this.form.Contents
      ? JSON.parse(this.form.Contents)
      : []
    this.coverImageSrc = this.form.CoverImageUrl
  }
}
</script>
